import { Button, Icon, Modal, Typography } from "@/components/atoms";

interface DriversVehicleMovedModalProps {
  open: boolean;
  onClose: () => void;
}

export const DriversVehicleMovedModal = ({ open, onClose }: DriversVehicleMovedModalProps) => {
  return (
    <Modal open={open} onClose={onClose} className="w-[85vw] !p-6 md:w-[500px]">
      <div className="flex flex-col">
        <Typography variant="title">My Driver&apos;s Vehicle has moved</Typography>
        <Typography variant="paragraph" className="mt-1 text-neutral-dark-gray">
          This tab is now managed in the <span className="font-semibold text-neutral-black">new Vehicle Manager</span>
        </Typography>

        <div className="mt-6 flex flex-col divide-y divide-neutral-mid-gray">
          <div className="flex gap-3 pb-5">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-vivid-purple-overlay">
              <Icon name="Danger" size="md" className="text-vivid-purple-dark" />
            </div>
            <div>
              <Typography variant="action">You&apos;re in view-only mode</Typography>
              <Typography variant="paragraph" className="mt-1 text-neutral-dark-gray">
                What you see here is a read-only snapshot. To manage, approve, or update driver vehicles, go to the new Vehicle Manager.
              </Typography>
            </div>
          </div>

          <div className="flex gap-3 py-5">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-vivid-purple-overlay">
              <Icon name="Timer1" size="md" className="text-vivid-purple-dark" />
            </div>
            <div>
              <Typography variant="action">Drivers need to update their vehicle first</Typography>
              <Typography variant="paragraph" className="mt-1 text-neutral-dark-gray">
                Since these are your drivers&apos; vehicles, only they can update the details from their Driver App. Submitted vehicles will stay in a{" "}
                <span className="font-semibold text-neutral-black">pending state</span> until each driver updates their vehicle.
              </Typography>
            </div>
          </div>

          <div className="flex gap-3 pt-5">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-vivid-purple-overlay">
              <Icon name="TickCircle" size="md" className="text-vivid-purple-dark" />
            </div>
            <div>
              <Typography variant="action">Your role kicks in after they update</Typography>
              <Typography variant="paragraph" className="mt-1 text-neutral-dark-gray">
                Once a driver updates their vehicle, you&apos;ll be able to review and approve it in the new Vehicle Manager, including selecting the{" "}
                <span className="font-semibold text-neutral-black">new</span> correct vehicle type.
              </Typography>
            </div>
          </div>
        </div>

        <div className="mt-5 rounded-lg bg-neutral-gray p-4">
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            <span className="font-semibold">Let your drivers know:</span> Ask them to open their Driver App and update their vehicle details.
          </Typography>
        </div>

        <Button variant="primary" size="lg" className="mt-6" onClick={onClose}>
          View My Drivers&apos; Vehicle
        </Button>
      </div>
    </Modal>
  );
};
